module.exports = __webpack_public_path__ + "img/air3.2793fb39.jpg";